import React, { useContext, useEffect } from 'react';
import NavContext from "../NavContext";
var HeaderNav = function (_a) {
    var children = _a.children;
    var _b = useContext(NavContext), setHasMenu = _b.setHasMenu, setOpenMenuMobile = _b.setOpenMenuMobile;
    useEffect(function () {
        setHasMenu(true);
    }, [setHasMenu]);
    return (React.createElement("div", { className: "fr-header__menu fr-modal", id: "modal-menu", "aria-labelledby": "button-menu-mobile" },
        React.createElement("div", { className: "fr-container" },
            React.createElement("button", { className: "fr-link--close fr-link", "aria-controls": "modal-menu", type: "button", onClick: function () { return setOpenMenuMobile(false); } }, "Fermer"),
            children)));
};
export default HeaderNav;
